/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY
// See angular/tools/gulp-tasks/cldr/extract.js

const u = undefined;

export default [
  [
    ['mitjanit', 'mat.', 'matí', 'md', 'tarda', 'vespre', 'nit'],
    ['mitjanit', 'matinada', 'matí', 'migdia', 'tarda', 'vespre', 'nit'], u
  ],
  [['mitjanit', 'matinada', 'matí', 'migdia', 'tarda', 'vespre', 'nit'], u, u],
  [
    '00:00', ['00:00', '06:00'], ['06:00', '12:00'], ['12:00', '13:00'], ['13:00', '19:00'],
    ['19:00', '21:00'], ['21:00', '24:00']
  ]
];
